module.exports = __webpack_public_path__ + "static/media/cherry-welcome.0753893d.png";